module.exports = __webpack_public_path__ + "static/countryBG-abd68a2c30c3ac31a13a6ba0039ee3d0.png";